// Wiek odczytu mety w widokach /finish i /meta-korona (spiker): świeże wejście jest wyróżnione
// i przez FRESH_MS stopniowo wygasa, starsze — bladsze. Wiek = teraz − chwila mety
// (nie chwila dotarcia do przeglądarki).

export const FRESH_MS = 2 * 60 * 1000
export const AGE_TICK_MS = 5000

// 'fresh' | 'old' | '' (brak czasu mety — bez wyróżnienia i bez wyszarzenia).
export function finishAgeState (finishMs, nowMs) {
  if (finishMs == null || !Number.isFinite(finishMs)) return ''
  return nowMs - finishMs < FRESH_MS ? 'fresh' : 'old'
}

// Ile zostało wyróżnienia: 1 = przed chwilą, 0 = po FRESH_MS.
export function freshness (finishMs, nowMs) {
  if (finishMs == null || !Number.isFinite(finishMs)) return 0
  return Math.min(1, Math.max(0, 1 - (nowMs - finishMs) / FRESH_MS))
}

// Tło i obwódka świeżego kafelka wygasające liniowo do zwykłych kolorów (kolejne kroki zegara
// wygładza `transition` w widoku). Bez wsparcia `color-mix` zostaje stałe tło z klasy `is-fresh`.
export function freshHighlightStyle (finishMs, nowMs) {
  const percent = Math.round(freshness(finishMs, nowMs) * 100)
  return {
    backgroundColor: `color-mix(in srgb, var(--sledz-highlight) ${percent}%, var(--sledz-surface))`,
    borderColor: `color-mix(in srgb, var(--sledz-highlight-flash) ${percent}%, var(--sledz-border-soft))`
  }
}
